'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const MoreServicesAccordion = ({ services }: { services?: TDynamicData[] }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <Accordion
        collapsible
        type="single"
        className={cn('ea-services-accordion', 'w-full px-6 sm:px-0 md:max-w-[500px]')}
      >
        {services?.map(service => (
          <AccordionItem
            key={service.name}
            value={service.name}
            className={cn('ea-services-accordion__item', '')}
          >
            <AccordionTrigger
              value={service.name}
              className={cn(
                'ea-services-accordion__trigger',
                'flex w-full items-center justify-between gap-4 text-left text-base font-semibold hover:no-underline sm:text-lg',
              )}
            >
              {service.name}
            </AccordionTrigger>
            <AccordionContent>
              <HtmlRendererRaw
                className={cn('ea-more-service-accordion', 'ea-html-description', 'w-full')}
                html={service.fields[0]?.value}
              />
              {service.fields[2]?.images && service.fields[2]?.images.length > 0 && (
                <div className="grid w-full grid-cols-3 gap-3 pt-6">
                  {service.fields[2]?.images.map((image, index) => (
                    <div
                      key={index}
                      className="relative col-span-1 aspect-square w-full cursor-pointer"
                      onClick={handleOpenGallery(service.fields[2]?.images, index)}
                    >
                      <Image
                        src={image.url}
                        alt={resolveImageAlt(image, undefined)}
                        fill
                        style={{ objectFit: 'cover', objectPosition: 'center' }}
                        quality={100}
                        sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 33vw"
                        loading="eager"
                      />
                    </div>
                  ))}
                </div>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
};
